<template>
  <el-dialog
    v-el-drag-dialog
    :append-to-body="appendToBody"
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Accrue')"
    width="450px"
    :close-on-click-modal="false"
  >
    <el-form label-width="60px" label-position="left">
      <span style="font-size: 15px;font-weight: bold">{{ $t('CargoMsg.Cargo_CommissionRole') }}</span>
      <div style="display: flex; padding: 5px">
        <el-checkbox v-model="from.customsProvision" no="checkCustoms">{{ $t('CargoMsg.Cargo_CustomsProvision') }}</el-checkbox>
        <el-checkbox v-model="from.opProvision" no="checkOp">{{ $t('CargoMsg.Cargo_OperationProvision') }}</el-checkbox>
        <el-checkbox v-model="from.opTicketProvision" no="checkOpTicket">{{ $t('CargoMsg.Cargo_OperationTicketProvision') }}</el-checkbox>
        <el-checkbox v-model="from.csProvision" no="checkCsr">{{ $t('CargoMsg.Cargo_CustomerServiceProvision') }}</el-checkbox>
      </div>
      <div style="display: flex; padding: 5px">
        <el-checkbox v-model="from.businessProvision" no="checkBusiness">{{ $t('CargoMsg.Cargo_BusinessProvision') }}</el-checkbox>
        <el-checkbox v-model="from.salesProvision" no="checkSales">{{ $t('CargoMsg.Cargo_SalesProvision') }}</el-checkbox>
      </div>
      <span style="font-size: 15px;font-weight: bold">{{ $t('CargoMsg.Cargo_LockLimit') }}</span>
      <div style="display: flex; padding: 5px">
        <el-checkbox v-model="from.lockCharge" no="checkLockArAp">{{ $t('CargoMsg.Cargo_LockAccountsReceivableAndPayableEntry') }}</el-checkbox>
      </div>
    </el-form>
    <div style=" display: flex; align-items: center;justify-content: center;">
      <div style="margin-bottom: 10px; margin-top: 10px">
        <div style="display: inline-block">
          <el-button type="primary" no="1" style="margin-left: 5px;" @click="confirmHandler"> {{ $t('CargoMsg.Cargo_Confirm') }} </el-button>
          <el-button no="2" style="margin-left: 5px;" @click="innerVisible = false"> {{ $t('CargoMsg.Cargo_Cancel') }} </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'AccrueSelectDialog',
  props: {
    visible: { type: Boolean, required: true },
    appendToBody: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      from: {
        customsProvision: false,
        opProvision: false,
        opTicketProvision: false,
        csProvision: false,
        businessProvision: false,
        salesProvision: false,
        lockCharge: false
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.innerVisible) {
      this.init()
    }
  },
  methods: {
    clear() {
      this.from.customsProvision = false
      this.from.opProvision = false
      this.from.opTicketProvision = false
      this.from.csProvision = false
      this.from.businessProvision = false
      this.from.salesProvision = false
      this.from.lockCharge = false
    },
    init() {
      this.clear()
    },
    confirmHandler() {
      this.$emit('accrueSelect', this.from)
      this.innerVisible = false
    }
  }
}
</script>
